module.exports = __webpack_public_path__ + "img/live_yeebet.4082270c.png";